import React from 'react';
import { BookOpenIcon, CompassIcon, ListChecksIcon, BarChart3Icon, LayoutPanelLeftIcon, ZapIcon, PrinterIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
const deliverables = [{
  Icon: BookOpenIcon,
  title: 'Full 6-volume command center',
  text: 'Six complete modules covering the organization of the aligner workflow.'
}, {
  Icon: CompassIcon,
  title: 'Master case map',
  text: 'See the entire case journey from beginning to completion.'
}, {
  Icon: ListChecksIcon,
  title: '30+ workflow checklists',
  text: 'Practical organizational checklists for key stages.'
}, {
  Icon: BarChart3Icon,
  title: 'Case trackers',
  text: 'Keep appointments, progress, documentation, and case status organized.'
}, {
  Icon: LayoutPanelLeftIcon,
  title: 'Case review boards',
  text: 'Structured spaces for organizing the information you need to review.'
}, {
  Icon: ZapIcon,
  title: 'Quick command system',
  text: 'Find the right resource without searching through an entire manual.'
}, {
  Icon: PrinterIcon,
  title: 'Printable + digital tools',
  text: 'Use the system digitally or print the components you use most.'
}];
export function WhatYouGet() {
  return <section className="w-full bg-mist py-14 md:py-20" aria-labelledby="get-title" data-id="element-295" data-mp="39vl2du9awofv">
      <div className="mx-auto max-w-5xl px-4 sm:px-6" data-id="element-296" data-mp="39ti4ko1wpr0l">
        <h2 id="get-title" className="text-center font-display text-[26px] font-black uppercase leading-tight tracking-tight text-navy-950 sm:text-4xl" data-id="element-297" data-mp="3dwoj0iz6aoi5">
          What Do You Get Instantly?
        </h2>

        <ul className="mt-8 grid gap-3 sm:grid-cols-2 md:mt-12 md:gap-4" data-id="element-298" data-mp="3npc9yx3h1y8y">
          {deliverables.map(({
          Icon,
          title,
          text
        }) => <li key={title} className="flex flex-col rounded-2xl border border-navy-900/10 bg-white px-5 py-5 shadow-card" data-id="element-299" data-mp="1gkvco5bcgkn">
              <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-brand-100" data-id="element-300" data-mp="5fa5m7v21i02">
                <Icon className="h-5 w-5 text-brand-600" aria-hidden="true" data-id="element-301" data-mp="22fwh0zbgijws" />
              </span>
              <h3 className="mt-4 font-display text-[15px] font-black uppercase leading-snug tracking-wide text-navy-950 sm:text-base" data-id="element-302" data-mp="1xhctwvl4n22u">
                {title}
              </h3>
              <p className="mt-2 text-[14px] leading-snug text-navy-800/75" data-id="element-303" data-mp="26ikrtcjqe0we">{text}</p>
            </li>)}
        </ul>

        <div className="mx-auto mt-10 max-w-2xl text-center" data-id="element-304" data-mp="2lal6seqn0nrd">
          <p className="font-display text-xl font-black uppercase leading-tight text-navy-950 sm:text-2xl" data-id="element-305" data-mp="2g95nar43ypb3">
            Your next aligner case doesn’t have to start with a blank page.
          </p>
          <p className="mt-3 text-[15px] leading-relaxed text-navy-800/80" data-id="element-306" data-mp="2q8d11fer8lyq">
            Download the Commander and organize your next case using a structured visual workflow.
          </p>
          <div className="mt-7" data-id="element-307" data-mp="vv5cg5hdh6lj">
            <CTAButton data-id="element-308" data-mp="vvx08u4qa019" />
          </div>
        </div>
      </div>
    </section>;
}